<template>
  <div id="consent-marketing-modal-container">
    <b-modal
      id="consent-marketing-modal"
      v-model="showmodal"
      hide-header
      hide-footer
      centered
      no-close-on-backdrop
      no-close-on-esc
    >
      <div :class="currentLocale">
        <div class="body">
          <div class="close-container">
            <img
              src="@/assets/images/close_gray.svg"
              class="close"
              alt=""
              @click="closeModal()"
            />
          </div>
          <img
            src="@/assets/images/icon_gift_box.svg"
            alt="success icon"
            class="icon"
          />
          <span class="title">
            {{ lbl.consent_marketing_message.title }}
          </span>
          <span class="description">
            {{ lbl.consent_marketing_message.description }}
          </span>
        </div>
        <div class="button-container">
          <b-button
            id="close-button"
            block
            class="close-button"
            :style="{
              backgroundColor: buttonColor,
              border: buttonColor,
              color: buttonTextColor,
            }"
            crm_at="close_button"
            @click="allowConsentMarketing()"
          >
            {{ lbl.consent_marketing_message.button }}
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import CommonMixin from '@/mixin/CommonMixin'
import Locale from '@/helper/Locale.js'

export default {
  name: 'ConsentMarketingModal',
  mixins: [CommonMixin],
  props: {
    buttonColor: String,
    buttonTextColor: String,
  },
  data() {
    return {
      showmodal: true,
      currentLocale: Locale.getLocale(),
    }
  },
  methods: {
    allowConsentMarketing() {
      this.$bvModal.hide('consent-marketing-modal')
      this.$emit('allowConsentMarketing')
    },
    closeModal() {
      this.$bvModal.hide('consent-marketing-modal')
      this.$emit('closeConsentMarketing')
    },
  },
}
</script>
<style lang="scss">
@import '@/style/_mixin.scss';

#consent-marketing-modal > .modal-dialog {
  padding: 0;
  border-radius: 10px;

  .modal-content {
    background-color: #fff;
    border: solid 1px #f5f5f5;
    border-radius: 16px;
    padding: 24px 16px 32px;
    margin: auto 12px;

    .modal-body {
      color: #616161;
      font-size: 14px;
      padding: 0;
      line-height: 1.57;
      letter-spacing: 0.15px;
      text-align: center;

      .close-container {
        width: 100%;
        .close {
          text-align: right;
        }
      }
      .body {
        display: flex;
        align-items: center;
        margin-bottom: 24px;
        flex-direction: column;

        .icon {
          width: 120px;
          height: 120px;
          margin-bottom: 24px;
        }

        .title {
          font-weight: 500;
          font-size: 24px;
          color: $color-modal-title;
          margin-bottom: 8px;
        }
        .description {
          font-size: 16px;
          font-weight: 300;
          color: $color-modal-desc;
        }
      }
    }

    .button-container {
      width: 100%;

      .close-button {
        font-size: 18px;
        font-weight: 500;
        text-align: center;
        justify-content: center;
        align-items: center;
        padding: 16px;
        border-radius: 100px;
      }
    }
  }
}
</style>
